<template>
  <!-- 按钮渲染组件 -->
  <div :class="['btnCompnentBox', alignClass]">
    <div v-for="(item, index) in data" :key="index" @click.stop="clickBtn(item)" :class="getcalss(item)">
      <slot>{{ item.text }}</slot>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import _ from 'lodash'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    align: {
      // left/center/right/around/between
      type: String,
      default: 'center'
    },
    size: {
      // large/normal/small/couponSize
      type: String,
      default: 'normal'
    }
  },
  setup(props, { emit }) {
    let { data, align, size } = toRefs(props)
    const state = reactive({
      data: data.value,
      align: align.value,
      size
    })
    // 触发点击
    let clickBtn = _.debounce(v => {
      emit('click', v)
    }, 500)
    // 计算水平对齐方式
    const alignClass = computed(() => {
      const alignClassObj = {
        left: 'btnCompnentLeft',
        center: 'btnCompnentCenter',
        right: 'btnCompnentRight',
        around: 'btnCompnentAround',
        between: 'btnCompnentBetween'
      }
      return alignClassObj[state.align] || ''
    })
    const getcalss = item => {
      let btnClas = item.class ? item.class : []
      let type = item.type ? item.type : ''
      let size = item.size ? item.size : state.size
      return ['btn', type, size, ...btnClas]
    }
    return {
      ...toRefs(state),
      clickBtn,
      alignClass,
      getcalss
    }
  }
}
</script>
<style lang="scss" scoped>
.btnCompnentBox {
  display: flex;
  text-align: center;
  //大号尺寸
  .large {
    width: 335px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  // 标准尺寸
  .normal {
    width: 160px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
  }
  // 优惠券
  .couponSize {
    width: 104px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }
  // 小号尺寸
  .small {
    width: 88px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
  }
  // 小号尺寸
  .mini {
    width: 60px;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
  }
  .btn {
    display: inline-block;
    color: #999;
    text-align: center !important;
    background-color: #fff;
    border: 1px solid #eee;
  }
  .btn + .btn {
    margin-left: 16px;
  }
  // 活动类型
  .active {
    color: #fff;
    background-color: #3088c5;
    border: 1px solid#3088c5;
  }
  // 警告类型
  .warn {
    color: #c30000;
    background-color: #fff;
    border: 1px solid #c30000;
  }
  // 禁用类型
  .disabled {
    color: #fff;
    background-color: #ccc;
    border: 1px solid #ccc;
  }
  // 不可用类型
  .unabled {
    color: #fff;
    background-color: rgba(48, 136, 197, 0.5);
    border: 1px solid transparent;
  }
  // 朴素类型
  .plain {
    color: #3088c5;
    background-color: transparent;
    border: 0.5px solid #3088c5;
  }
}
.btnCompnentRight {
  justify-content: flex-end;
}
.btnCompnentCenter {
  justify-content: center;
}
.btnCompnentLeft {
  justify-content: flex-start;
}
.btnCompnentBetween {
  justify-content: space-between;
}
.btnCompnentAround {
  justify-content: space-around;
}
</style>
